/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Requests_Desc_OrganizationInputs */



/**
* | output |
* | --- |
* | "Daily trend of total API requests across the organization" |
*
* @param {Dashboard_Requests_Desc_OrganizationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_requests_desc_organization = /** @type {((inputs?: Dashboard_Requests_Desc_OrganizationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Requests_Desc_OrganizationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Täglicher Trend der API-Anfragen in der gesamten Organisation")
	return /** @type {LocalizedString} */ ("Daily trend of total API requests across the organization")
});